import cv from "../assets/pdf/CV KALIL BELGOUMRI.pdf";
import moi from "../assets/png/moi.webp";
export const headerData = {
  name: "Kalil BELGOUMRI",
  title: "Web Developer",
  desciption:
    "There wasn't a bird in the sky, but that was not what caught her attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. She knew what was coming and she hoped she was prepared. ",
  image: moi,
  resumePdf: cv,
};
